(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gravitis-kit-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gravitis-kit-finder')) {
    customElements.define('gravitis-kit-finder', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.panels = Array.from(this.querySelectorAll('[data-finder-panel]'));
        this.cards = Array.from(this.querySelectorAll('[data-finder-result]'));
        if (!this.cards.length) return;
        this.results = this.querySelector('[data-finder-results]');
        this.progress = this.querySelector('[data-finder-progress]');
        this.states = new Set(['start', ...this.panels.map(panel => panel.dataset.finderPanel), ...this.cards.map(card => card.dataset.finderResult)]);
        this.clickHandler = event => {
          const button = event.target.closest('button[data-finder-state]');
          if (button && this.contains(button)) this.show(button.dataset.finderState, true, true);
        };
        this.historyHandler = () => this.show(new URL(window.location.href).searchParams.get('kit') || 'start', false, false);
        this.addEventListener('click', this.clickHandler);
        window.addEventListener('popstate', this.historyHandler);
        this.querySelectorAll('[data-finder-result-back]').forEach(button => { button.hidden = false; });
        this.progress.hidden = false;
        this.historyHandler();
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.clickHandler);
        window.removeEventListener('popstate', this.historyHandler);
        this.initialized = false;
      }
      show(requested, updateUrl, moveFocus) {
        const state = this.states.has(requested) ? requested : 'start';
        const card = this.cards.find(item => item.dataset.finderResult === state);
        let active = card;
        this.panels.forEach(panel => {
          panel.hidden = panel.dataset.finderPanel !== state;
          if (!panel.hidden) active = panel;
        });
        this.cards.forEach(item => { item.hidden = item !== card; });
        this.results.hidden = !card;
        const progress = card ? 'result' : state === 'start' ? 'start' : 'choice';
        this.progress.querySelectorAll('[data-progress]').forEach(label => { label.hidden = label.dataset.progress !== progress; });
        if (updateUrl) {
          const url = new URL(window.location.href);
          if (state === 'start') url.searchParams.delete('kit');
          else url.searchParams.set('kit', state);
          url.hash = this.id;
          window.history.pushState(window.history.state, '', url);
        }
        if (moveFocus && active) active.querySelector('h3')?.focus({ preventScroll: true });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
